import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

function SellDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Sell Out (R$)");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("Tipo_Selecao").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_Selecao")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app Sell">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Positivação Geral"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Sell Out (R$)"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Sell Out (R$)"
            />

            <FormControlLabel
              value="Sell In (R$)"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Sell In (R$)"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              {selectedValue === "Sell Out (R$)" ? (
                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="QXpbePs"
                >
                  <NativeObject
                    app={app}
                    key="QXpbePs"
                    reference={{ id: "QXpbePs" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Sell In (R$)" ? (
                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="QXpbePs"
                >
                  <NativeObject
                    app={app}
                    key="QXpbePs"
                    reference={{ id: "QXpbePs" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

SellDesktop.defaultProps = {
  app: null,
  config: {},
};

SellDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellDesktop;
